import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { VipMessagingCard } from '@shared-ui/lodging-property-offers';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiWrapperProps, withSharedUiPropertyOffers } from './shared-ui-property-offers';
import { SimpleLazyLoadWrapper } from 'components/common/lazy/simple-lazy-load-wrapper';

const PropertyHighlightWrapper: React.FC<SharedUiWrapperProps> = React.memo(({ inputs }) => (
  <ErrorBoundary label="hotel.property.highlights">
    <SimpleLazyLoadWrapper offset={400}>
      <UitkSpacing margin={{ blockend: 'three' }}>
        <div>
          <VipMessagingCard inputs={inputs} skipSsr={true} />
        </div>
      </UitkSpacing>
    </SimpleLazyLoadWrapper>
  </ErrorBoundary>
));

PropertyHighlightWrapper.displayName = 'PropertyHighlightWrapper';
export const SharedUiPropertyHighlightWrapper = withSharedUiPropertyOffers(PropertyHighlightWrapper);
